import {useEffect, useState} from 'react';

import {
  Avatar,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useBoolean,
} from '@chakra-ui/react';

import {getOrganizationById} from '../services/organizationsService';
import {Organization} from '../types/organizations';
import {OrganizationPickerList} from './OrganizationPickerList';

interface OrganizationPickerButtonProps {
  idOrganization: string;
}

export function OrganizationPickerButton(props: OrganizationPickerButtonProps) {
  const {idOrganization} = props;

  const [organization, setOrganization] = useState<Organization>();
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, modalState] = useBoolean();

  useEffect(() => {
    if (!idOrganization) {
      return;
    }
    setIsLoading(true);
    getOrganizationById(idOrganization)
      .then(setOrganization)
      .catch(console.error)
      .finally(() => setIsLoading(false));
  }, [idOrganization]);

  return (
    <>
      <Button
        padding={5}
        rounded='full'
        variant='outline'
        colorScheme='teal'
        isLoading={isLoading}
        onClick={modalState.on}
        maxW={{base: '200px', md: '360px', lg: '480px'}}
        sx={{
          '& > span:last-of-type': {minW: 0, overflow: 'hidden'},
        }}
        leftIcon={<Avatar size='sm' name={organization?.name} />}>
        <Text
          as='span'
          overflow='hidden'
          textOverflow='ellipsis'
          whiteSpace='nowrap'>
          {organization?.name || 'Cargando...'}
        </Text>
      </Button>
      <Modal isOpen={isModalOpen} onClose={modalState.off}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader mt={5}>Selecciona una organización</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <OrganizationPickerList onClose={modalState.off} />
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
